var map = {
	"./Asscher.png": 773,
	"./Asscher@2x.png": 315,
	"./Cushion.png": 774,
	"./Cushion@2x.png": 316,
	"./Emerald.png": 775,
	"./Emerald@2x.png": 317,
	"./Faceted Trapezoid.png": 776,
	"./Faceted Trapezoid@2x.png": 318,
	"./Half Moon.png": 777,
	"./Half Moon@2x.png": 319,
	"./Heart.png": 778,
	"./Heart@2x.png": 320,
	"./Marquise.png": 779,
	"./Marquise@2x.png": 321,
	"./Oval.png": 780,
	"./Oval@2x.png": 322,
	"./Pear.png": 781,
	"./Pear@2x.png": 323,
	"./Princess.png": 782,
	"./Princess@2x.png": 324,
	"./Radiant.png": 783,
	"./Radiant@2x.png": 325,
	"./Round.png": 784,
	"./Round@2x.png": 326,
	"./Step Cut Trapezoid.png": 785,
	"./Step Cut Trapezoid@2x.png": 327,
	"./Straight Baguette.png": 786,
	"./Straight Baguette@2x.png": 328,
	"./Tapered Baguette.png": 787,
	"./Tapered Baguette@2x.png": 329,
	"./Triangle.png": 788,
	"./Triangle@2x.png": 330,
	"./Trilliant.png": 789,
	"./Trilliant@2x.png": 331
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 499;



//////////////////
// WEBPACK FOOTER
// ./src/components/select-shapes/images ^\.\/.*\.png$
// module id = 499
// module chunks = 0